import React, { useEffect } from "react";
import { NodeViewWrapper, NodeViewContent } from "@tiptap/react";
import { Node as ProseMirrorNode } from "@tiptap/pm/model";
import { Editor } from "@tiptap/core";
import { cn } from '@/lib/utils'
import { AccordionGroupAttributes } from "./accordion-group-extension";

interface AccordionGroupNodeViewProps {
  node: ProseMirrorNode;
  editor: Editor;
  getPos: () => number | undefined;
  updateAttributes: (attributes: Record<string, any>) => void;
  deleteNode: () => void;
  selected: boolean;
}

export function AccordionGroupNodeView({
  node,
  editor,
  getPos,
  updateAttributes,
  deleteNode,
  selected,
}: AccordionGroupNodeViewProps) {
  const attrs = node.attrs as AccordionGroupAttributes;

  // Auto-delete if empty (similar to Plate implementation)
  useEffect(() => {
    // Check if the accordion group has no content or only empty content
    const shouldDelete =
      !node.content ||
      node.content.childCount === 0 ||
      (node.content.childCount === 1 &&
        node.content.child(0).type.name === "paragraph" &&
        node.content.child(0).content.size === 0);

    if (shouldDelete) {
      deleteNode();
    }
  }, [node.content, deleteNode]);

  return (
    <NodeViewWrapper
      className={cn(
        "group/accordiongroup relative my-5 p-0.5",
        selected && "ProseMirror-selectednode"
      )}
    >
      <div className="accordion-group-container relative">
        {/* Container for accordions - always single column with border */}
        <div className="overflow-hidden rounded-md border border-[var(--border)] p-0">
          <NodeViewContent />
        </div>
      </div>
    </NodeViewWrapper>
  );
}
